export default __webpack_public_path__ + "d60c68037d85f93c838993bccad5dded.svg";